import { alias, deserialize, optional, serializable } from 'serializr';
import { Base } from '@models/base.model';
import { Deserializable } from '@models/deserializable';
import { EntityType } from '../enums/entity-type.enum';
import { BulkActionType } from '../enums/bulk-action-type.enum';
import { Status, StatusConstant } from '../enums/status-constant.enum';

export class BulkAction extends Base implements Deserializable {
  @serializable
  public spec: string;

  @serializable
  public actionType: BulkActionType;

  @serializable(optional())
  public message: string;

  @serializable
  public entityType: EntityType;

  @serializable(optional())
  public data: JSON;

  @serializable
  public status: Status;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BulkAction, input));
  }
}
